"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    text = _ref.palette.text,
    shade = _ref.utils.shade;
  return {
    h1: {
      fontWeight: typography.fontWeightLight,
      fontSize: '28px',
      lineHeight: '38px',
      color: text.primary,
      letterSpacing: 0,
      margin: 0
    },
    h2: {
      fontSize: '22px',
      lineHeight: '46px',
      fontWeight: typography.fontWeightLight,
      letterSpacing: 0
    },
    h3: {
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: typography.fontWeightRegular,
      letterSpacing: 0
    },
    h4: {
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: typography.fontWeightRegular,
      letterSpacing: 0
    },
    subtitle1: {
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: typography.fontWeightRegular,
      letterSpacing: 0
    },
    caption: {
      fontSize: '12px',
      lineHeight: '17px',
      fontWeight: typography.fontWeightRegular,
      color: shade(text.primary, 6)
    },
    upper: {
      textTransform: 'uppercase'
    }
  };
}, {
  name: 'Typography'
});
exports.useStyles = useStyles;